<template>
  <LegalPage title="Terms &amp; Conditions" last-updated="August 30, 2025">
    <p>
      Welcome to Nilkhet Books. These Terms &amp; Conditions govern your use of
      our website and your purchase of books and related products from us. By
      accessing our website or placing an order, you agree to be bound by these
      terms. Please read them carefully.
    </p>

    <h2>1. About Us</h2>
    <p>
      Nilkhet Books is an online book retailer based in Dhaka, Bangladesh. Our
      registered address is Shop 146, 1st Floor, Gausul Azam Super Market,
      Nilkhet, Dhaka 1205.
    </p>

    <h2>2. Using Our Website</h2>
    <ul>
      <li>You must provide accurate and complete information when using our website.</li>
      <li>
        You are responsible for maintaining the confidentiality of your account
        and password and for all activity under your account.
      </li>
      <li>
        You agree not to use our website for any unlawful purpose or in any way
        that could damage, disable, or impair the site.
      </li>
    </ul>

    <h2>3. Products and Pricing</h2>
    <ul>
      <li>
        We make every effort to display our products, prices, and availability
        accurately. However, errors may occur, and we reserve the right to
        correct them.
      </li>
      <li>
        All prices are listed in Bangladeshi Taka (BDT) and are inclusive of
        applicable charges unless stated otherwise. Delivery charges are shown
        separately at checkout.
      </li>
      <li>
        Many of our titles are printed on order. Slight variations in cover
        finish, colour, or binding may occur between print runs.
      </li>
      <li>
        We reserve the right to change prices and to limit order quantities at
        any time without prior notice.
      </li>
    </ul>

    <h2>4. Orders</h2>
    <ul>
      <li>
        Placing an order constitutes an offer to purchase. An order is confirmed
        once you receive an order confirmation from us.
      </li>
      <li>
        We reserve the right to accept or decline any order, including where a
        product is unavailable, where there is a pricing error, or where we
        suspect fraudulent activity.
      </li>
      <li>
        Since many books are printed on order, please ensure your order details
        are correct before confirming.
      </li>
    </ul>

    <h2>5. Payment</h2>
    <p>
      We accept payment through bKash, Nagad, and other methods shown at
      checkout, as well as cash on delivery where available. All payments must be
      completed as per the method selected at the time of order.
    </p>

    <h2>6. Delivery</h2>
    <p>
      Delivery timelines, coverage, and charges are described in our
      <router-link to="/delivery-policy">Delivery Policy</router-link>, which
      forms part of these Terms.
    </p>

    <h2>7. Returns and Refunds</h2>
    <p>
      Our returns and replacement terms are described in our
      <router-link to="/return-refund-policy">Return &amp; Refund Policy</router-link>,
      which forms part of these Terms. In summary, because our books are printed
      on order, we do not accept general returns, but we will replace any copy
      found to have printing defects at no additional cost.
    </p>

    <h2>8. Intellectual Property</h2>
    <p>
      All content on this website, including text, graphics, logos, and images,
      is the property of Nilkhet Books or its licensors and is protected by
      applicable laws. You may not reproduce or use this content without our
      written permission.
    </p>

    <h2>9. Limitation of Liability</h2>
    <p>
      To the extent permitted by law, Nilkhet Books shall not be liable for any
      indirect or consequential loss arising from the use of our website or
      products. Our total liability for any order shall not exceed the amount you
      paid for that order.
    </p>

    <h2>10. Governing Law</h2>
    <p>
      These Terms &amp; Conditions are governed by the laws of the People's
      Republic of Bangladesh, and any disputes shall be subject to the exclusive
      jurisdiction of the courts of Dhaka.
    </p>

    <h2>11. Changes to These Terms</h2>
    <p>
      We may update these Terms &amp; Conditions from time to time. Continued use
      of our website after changes are posted constitutes acceptance of the
      updated terms.
    </p>

    <h2>12. Contact Us</h2>
    <div class="highlight-box">
      <p>
        <strong>Nilkhet Books</strong><br />
        Shop 146, 1st Floor, Gausul Azam Super Market, Nilkhet, Dhaka 1205<br />
        Phone: <a href="tel:+8801711086468">+880 1711 086 468</a><br />
        Email:
        <a href="mailto:nilkhetdotcom@gmail.com">nilkhetdotcom@gmail.com</a>
      </p>
    </div>
  </LegalPage>
</template>

<script>
import LegalPage from "@/components/LegalPage.vue";

export default {
  name: "TermsConditions",
  components: { LegalPage },
};
</script>
